export const styles = {
  // Empty State
  emptyStateContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '60vh',
  },

  // Basket List Status
  statusBox: (isMobile, type) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: isMobile ? 'flex-start' : 'center',
    color: type === 'executed' ? 'success.main' : 'warning.main',
    gap: 0.5,
  }),

  // Mobile Basket Card
  mobileStack: { p: 1 },
  mobileCard: { p: 1.5 },
  mobileCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 1,
  },
  mobileCardNameBox: { display: 'flex', alignItems: 'center', gap: 1 },
  mobileEditIconButton: { p: 0.5 },
  mobileEditIcon: { fontSize: '1rem' },
  mobileDivider: { my: 1 },
  mobileContentBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  mobileScripsBox: { flex: 1, display: 'flex', justifyContent: 'flex-start' },
  mobileStatusBox: { flex: 1, display: 'flex', justifyContent: 'center' },
  mobileActionsBox: { flex: 1, display: 'flex', justifyContent: 'flex-end' },

  // Desktop Table
  desktopTableContainer: { boxShadow: 'none' },
  desktopTableRow: {
    cursor: 'pointer',
    '&:hover': { backgroundColor: 'action.hover' },
  },

  // Main Baskets Component
  loadingBox: { display: 'flex', justifyContent: 'center', mt: 4 },
  mainContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  selectedBasketContainer: { display: 'flex', flexDirection: 'column', flex: 1 },
  selectedBasketHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: 1,
    pt: 1,
    gap: 1,
    position: 'relative',
  },
  selectedBasketTitleBox: { display: 'flex', alignItems: 'center', minWidth: 0 },
  backIconButton: { mr: { xs: 0, sm: 1 }, p: { xs: 0.5, sm: 1 } },
  backIcon: { fontSize: { xs: '1.2rem', sm: '1.5rem' } },
  basketNameTypography: {
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: { xs: 0.5, sm: 1 },
    fontSize: { xs: '1rem', sm: '1.25rem' },
    minWidth: 0,
  },
  basketNameSpan: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  statusChip: {
    height: { xs: 18, sm: 20 },
    fontSize: { xs: '0.65rem', sm: '0.7rem' },
  },
  actionButton: {
    py: { xs: 0.5, sm: 0.75 },
    px: { xs: 1, sm: 2 },
    fontSize: { xs: '0.7rem', sm: '0.875rem' },
    whiteSpace: 'nowrap',
    minWidth: 'auto',
  },
  playIcon: { fontSize: { xs: '1rem', sm: '1.5rem' } },

  // Dialogs
  dialogTitle: { fontWeight: 600 },
  dialogActions: { p: 2, pt: 0 },
};
